<template>
  <div class="localized-component">
    {{ namePlaceHolder }}
    <div
      class="form-group"
      v-if="field.label"
      :class="[{ 'input-group': true }, { 'has-label': field.label }]"
    >
      <label
        v-if="field.label"
        size="lg"
        :class="field.labelClasses + ' text-dark col-form-label '"
      >
        <h6 v-html="field.label" v-if="field.label"></h6>
        <h6 v-html="'&nbsp;'" v-else></h6>
        <span class="text-danger" v-if="field.required">*</span>
      </label>
    </div>

    <tab-nav :pills="true" id="pills-tab" class="mb-3">
      <tab-nav-items
        v-for="(locale, index) in localeData"
        :key="locale.locale"
        :active="index === 0"
        :id="'pills-' + locale.locale + '-tab'"
        :href="'#pills-' + locale.locale"
        :ariaControls="'pills-' + locale.locale"
        role="tab"
        ::ariaSelected="index === 0"
        :title="localeNames[locale.locale]"
      />
    </tab-nav>
    <tab-content id="pills-tabContent">
      <tab-content-item
        v-for="(locale, index) in localeData"
        :key="locale.locale"
        :active="index === 0"
        :id="'pills-' + locale.locale"
        :aria-labelled-by="'pills-' + locale.locale + '-tab'"
      >
        <ValidationProvider
          v-if="locale.locale === 'en'"
          name="name"
          :rules="field.rules"
          v-slot="{ passed, errors, failedRules }"
        >
          <b-form-group
            :label="namePlaceHolder"
            label-for="'input-' + locale.locale"
          >
            <b-form-input
              :id="'input-' + locale.locale + '-' + sanitizedPlaceholder"
              type="text"
              v-model="locale.name"
              :class="{
                'is-invalid': errors.length > 0,
                'border-success': passed
              }"
              :placeholder="namePlaceHolder"
            />
            <b-form-invalid-feedback v-if="errors.length > 0">
              {{ validation_messages[locale.locale].required }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>

        <b-form-group
          v-else
          :label="namePlaceHolder"
          label-for="'input-' + locale.locale"
        >
          <b-form-input
            :id="'input-' + locale.locale + '-' + sanitizedPlaceholder"
            type="text"
            v-model="locale.name"
            :placeholder="namePlaceHolder"
          />
        </b-form-group>

        <b-form-group
          :label="descriptionPlaceHolder"
          label-for="'textarea-' + locale.locale"
        >
          <b-form-textarea
            :id="'textarea-' + locale.locale"
            v-model="locale.description"
            :placeholder="descriptionPlaceHolder"
          ></b-form-textarea>
        </b-form-group>
      </tab-content-item>
    </tab-content>
  </div>
</template>

<script>
import { methods } from "vue2-dropzone";
import { __localeNames, __localesModel } from "../Utils/locales";
export default {
  name: "LocalizedComponent",
  props: ["localeValues", "field", "inList"],
  watch: {
    localeValues: {
      deep: true,
      handler(val) {
        this.localeData = val;
      }
    }
  },
  computed: {
    sanitizedPlaceholder() {
      if (!this.namePlaceHolder) return "";
      return this.namePlaceHolder
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");
    },
    namePlaceHolder() {
      return this.field.placeholder || "Enter the name";
    },
    descriptionPlaceHolder() {
      return this.field.placeholder2 || "Enter the description";
    },
    validation_messages() {
      return (
        this.field.validation_messages || {
          en: {
            required: "Name is required"
          },
          ar: {
            required: "الاسم مطلوب"
          }
        }
      );
    }
  },
  data() {
    return {
      localeNames: __localeNames,
      localeData: __localesModel
    };
  },
  mounted() {
    this.localeData = this.localeValues || __localesModel;
  }
};
</script>

<style scoped></style>
